import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
	selector: 'app-login-web',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './login.component.html',
})
export class LoginWebComponent {
	private router = inject(Router);
	private authService = inject(AuthService);

	username = signal('');
	password = signal('');
	loginError = signal(false);
	loading = signal(false);
	showPassword = signal(false);

	login() {
		if (!this.username() || !this.password()) return;
		this.loading.set(true);
		this.loginError.set(false);

		this.authService.login(this.username(), this.password()).subscribe({
			next: () => {
				this.loading.set(false);
				this.router.navigate(['/web/private']); // Redirigi all'area privata web
			},
			error: () => {
				this.loading.set(false);
				this.loginError.set(true);
			},
		});
	}

	goToRecuperaPassword() {
		this.router.navigate(['/web/public/recupera-password']);
	}

	loginMicrosoft() {
		window.location.href = 'https://signbookapi.kefirma.it/api/public/login-microsoft/start?platform=web';
	}
}
